import { t } from '@/i18n/i18ns'

export default {
  name: 'plan-card-premium',
  components: {},
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {
    mainFeatures () {
      return [
      `${t('planCard.tenUsersAndRoles')}`,
      `${t('planCard.tenGBPlayerStorage')}`,
      `${t('planCard.twelveTemplatesCustomizable')}`
      ]
    },
    featureDetails () {
      return [
        {
          id: 'twelveApps',
          label: `${t('planCard.twelveApps')}`
        },
        {
          id: 'assetGrouping',
          label: `${t('planCard.assetGrouping')}`
        },
        {
          id: 'scheduleAutomation',
          label: `${t('planCard.scheduleAutomation')}`
        },
        {
          id: 'priorityScheduling',
          label: `${t('planCard.priorityScheduling')}`
        },
        {
          id: 'alerts',
          label: `${t('planCard.alerts')}`
        },
        {
          id: 'audio',
          label: `${t('planCard.audio')}`
        },
        {
          id: 'videoWallSupport',
          label: `${t('planCard.videoWallSupport')}`
        }
      ]
    }
  },
  methods: {
    isFeatureTwelveApps (item) {
      return item.id === 'twelveApps'
    },
    isFeatureVideoWallSupport (item) {
      return item.id === 'videoWallSupport'
    }
  },
  mounted () {}
}
